import React, { useState } from "react";
import MaterialTable from "material-table";
import { translator } from "../../utils/i18n";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteAppointment,
  // initValues,
  switchWidgetAppointment
} from "../../utils/fetcher";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
import DateRangeIcon from "@material-ui/icons/DateRange";
import QueryBuilderIcon from "@material-ui/icons/QueryBuilder";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import PhoneOutlinedIcon from "@material-ui/icons/PhoneOutlined";
import AlertDialog from "../../components/AlertDialog";
import { setMessageWithCode } from "../../actions";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Card,
  CardContent,
  CardMedia,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  IconButton,
  makeStyles,
  Tooltip,
  Typography
} from "@material-ui/core";
function MyAppointments() {
  const dispatch = useDispatch();
  const listAppointments = useSelector(state =>
    state.patientArea.myAppointments ? state.patientArea.myAppointments : []
  );
  const deleteAppointmentFunc = id => dispatch(deleteAppointment(id));
  const message = useSelector(state => state.messageWithCode);
  const [selectedAppointments, setSelectedAppointments] = useState([]);
  const [deleteAppointmentId, setDeleteAppointmentId] = useState(undefined);

  const state = {
    columns: [
      { title: `contenu`, field: "content", filtering: false },
      { title: `Nom`, field: "lastName", filtering: false },
      { title: `Prénom`, field: "firstName" },
      { title: `Nom du praticien`, field: "infoDoctor" },
      { title: `Motif`, field: "motif" },
      { title: `Date`, field: "date", filtering: false }
    ]
  };

  const useStyles = makeStyles(() => ({
    root: {
      display: "flex"
    },
    details: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      flex: 8,
      "&:last-child": {
        padding: "5px 14px"
      }
    },
    expanded: {},
    accordion: {
      margin: 0,
      padding: 0,
      "&$expanded": {
        margin: 0
      }
    },
    accordionContent: {
      margin: 0,
      padding: 0,
      flexGrow: 1,
      display: "block",
      "&$expanded": {
        boxShadow: "0 5px 10px 0 lightgrey",
        margin: 0
      }
    },
    accordionDetails: {
      padding: "16px"
    },
    accordionDetailsLine: {
      display: "flex"
    },
    accordionDetailsPicto: {
      width: "3%",
      margin: "0 1%"
    },
    appointmentIcon: {
      padding: "4%",
      background: "#009eff",
      flex: 1
    },
    informationElement: {
      display: "flex",
      alignItems: "flex-end"
    },
    cardPicto: {
      padding: 5
    },
    mr5: {
      marginRight: "5px"
    }
  }));

  const classes = useStyles();

  const edit = token => {
    dispatch(switchWidgetAppointment(token));
  };

  // const goToEdit = urlEdit => {
  //   if (initValues().iframe) {
  //     window.top.postMessage(
  //       JSON.stringify({
  //         url: urlEdit,
  //         mode: "navigate"
  //       }),
  //       "*"
  //     );
  //   } else {
  //     window.location.href = urlEdit;
  //   }
  // };
  const goToEdit = urlEdit => {
    const currentURL = window.location.href;
    const newParams = `token_rdv=${urlEdit}`;
    const separator = currentURL.includes("?") ? "&" : "?";
    const updatedURL = currentURL + separator + newParams;
    window.location.href = updatedURL;
  };

  const getAppointmentCard = appointmentInfo => {
    const isSelected = selectedAppointments.includes(
      appointmentInfo.appointmentId
    );
    const clickNewValue = isSelected
      ? selectedAppointments.filter(value => {
          return value != appointmentInfo.appointmentId;
        })
      : selectedAppointments.concat([appointmentInfo.appointmentId]);
    return (
      <Accordion className={classes.accordion}>
        <AccordionSummary
          classes={{
            content: classes.accordionContent,
            root: classes.accordion,
            expanded: classes.expanded
          }}
        >
          <Card className={classes.root}>
            <CardMedia
              component="img"
              src="images/appointmentTaken.svg"
              alt="Rendez-vous pris"
              classes={{ root: classes.appointmentIcon }}
            />
            <CardContent className={classes.details}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography component="div" variant="h6" color="primary">
                  {appointmentInfo.civilityDoctor}{" "}
                  {appointmentInfo.firstNameDoctor}{" "}
                  {appointmentInfo.lastNameDoctor}
                </Typography>

                <div>
                  {appointmentInfo.token && (
                    <Tooltip
                      color="primary"
                      title={translator()._("W_MODIFIER")}
                    >
                      <IconButton
                        className={classes.cardPicto}
                        color="primary"
                        aria-label="edit"
                        onClick={() =>
                          appointmentInfo.token
                            ? goToEdit(appointmentInfo.token)
                            : edit(appointmentInfo.token)
                        }
                      >
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                  )}
                  {appointmentInfo.deletable && (
                    <Tooltip title={translator()._("W_SUPPRIMER")}>
                      <IconButton
                        className={classes.cardPicto}
                        color="primary"
                        aria-label="edit"
                        onClick={() =>
                          setDeleteAppointmentId(appointmentInfo.appointmentId)
                        }
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  )}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between"
                }}
              >
                <div className={classes.informationElement}>
                  <PermIdentityIcon className={classes.mr5} />
                  {appointmentInfo.firstName} {appointmentInfo.lastName}
                </div>
                <div className={classes.informationElement}>
                  <DateRangeIcon className={classes.mr5} />
                  {appointmentInfo.date}
                </div>
                <div className={classes.informationElement}>
                  <QueryBuilderIcon className={classes.mr5} />
                  {appointmentInfo.Hour}
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "end" }}>
                <Typography
                  onClick={() => {
                    setSelectedAppointments(clickNewValue);
                  }}
                  color="primary"
                  style={{
                    textDecoration: "underline",
                    cursor: "pointer",
                    display: "flex"
                  }}
                >
                  Voir en detail{" "}
                  {isSelected ? (
                    <KeyboardArrowUpIcon />
                  ) : (
                    <KeyboardArrowDownIcon />
                  )}
                </Typography>
              </div>
            </CardContent>
          </Card>
        </AccordionSummary>
        <AccordionDetails className={classes.accordionDetails}>
          <div
            style={{ display: "flex", flexDirection: "column", width: "100%" }}
          >
            {appointmentInfo.motif && (
              <div className={classes.accordionDetailsLine}>
                <img
                  src="images/stethoscope.svg"
                  className={classes.accordionDetailsPicto}
                />
                <span>{appointmentInfo.motif}</span>
              </div>
            )}
            {(appointmentInfo.address ||
              appointmentInfo.cp ||
              appointmentInfo.city) && (
              <div className={classes.accordionDetailsLine}>
                <HomeOutlinedIcon className={classes.accordionDetailsPicto} />
                <span>
                  {appointmentInfo.address} {appointmentInfo.cp}{" "}
                  {appointmentInfo.city}
                </span>
              </div>
            )}
            {appointmentInfo.tel && (
              <div className={classes.accordionDetailsLine}>
                <PhoneOutlinedIcon className={classes.accordionDetailsPicto} />
                <span>{appointmentInfo.tel}</span>
              </div>
            )}
          </div>
        </AccordionDetails>
      </Accordion>
    );
  };

  const buildHtml = () => {
    let newData = [];
    if (listAppointments) {
      newData = listAppointments.map(item => {
        const html = getAppointmentCard(item);

        return {
          content: html,
          appointmentId: item.appointmentId,
          lastName: item.lastName,
          firstName: item.firstName,
          infoDoctor: item.infoDoctor,
          motif: item.motif,
          date: item.date,
          Hour: item.Hour
        };
      });
    }
    return newData;
  };

  return (
    <div className="wrap-custom-table">
      {deleteAppointmentId !== undefined && (
        <Dialog
          open={open}
          onClose={() => setDeleteAppointmentId(undefined)}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogContent>
            <DialogContentText>
              {translator()._(
                "W_SOUHAITEZ_VOUS_VRAIMENT_SUPPRIMER_RENDEZ_VOUS"
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              onClick={() => setDeleteAppointmentId(undefined)}
              color="primary"
            >
              {translator()._("W_ANNULER")}
            </Button>
            <Button
              onClick={() => {
                deleteAppointmentFunc(deleteAppointmentId);
                setDeleteAppointmentId(undefined);
              }}
              color="primary"
              autoFocus
            >
              {translator()._("W_OUI")}
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {message && message.code === -1 && (
        <AlertDialog
          isHideTitle={true}
          content={message.text}
          onClick={() => {
            dispatch(setMessageWithCode({}));
          }}
          isResetAlert={true}
        />
      )}
      <h1 className="title-page">{translator()._("CP_MENU_MES_RDV")}</h1>
      <div>
        {translator()._("W_VOUS_AVEZ")}{" "}
        <strong>{listAppointments.length}</strong>{" "}
        {translator()._("CP_MENU_MES_RDV")}
      </div>
      <div className="wrap-inner-table filter-disabled">
        <MaterialTable
          title=""
          columns={state.columns}
          data={buildHtml()}
          showFirstLastPageButtons={true}
          options={{
            actionsColumnIndex: -1,
            maxBodyHeight: 350,
            pageSize: 3,
            cellStyle: {
              padding: 0,
              paddingRight: "10px"
            },
            rowStyle: {
              margin: "10px "
            }
          }}
          localization={{
            pagination: {
              labelDisplayedRows: "{from}-{to} of {count}",
              previousTooltip: `${translator()._("W_PREVIOUS_PAGE")}`,
              nextTooltip: `${translator()._("W_NEXT_PAGE")}`,
              lastTooltip: `${translator()._("W_LAST_PAGE")}`,
              firstTooltip: `${translator()._("W_FIRST_PAGE")}`
            },
            toolbar: {
              nRowsSelected: "{0} row(s) selected",
              searchPlaceholder: `${translator()._("CP_SEARCH")}`
            },
            header: {
              actions: "Actions"
            },
            body: {
              deleteTooltip: `${translator()._("W_SUPPRIMER")}`,
              emptyDataSourceMessage: `${translator()._(
                "CP_WELCOME_NO_RDV_PREVU"
              )}`,
              filterRow: {
                filterTooltip: "Filter"
              },
              editRow: {
                deleteText: `${translator()._(
                  "W_SOUHAITEZ_VOUS_VRAIMENT_SUPPRIMER_RENDEZ_VOUS"
                )}`,
                cancelTooltip: `${translator()._("W_ANNULER")}`,
                saveTooltip: `${translator()._("W_STEP_BOUTON_CONTINUER")}`
              }
            }
          }}
        />
      </div>
    </div>
  );
}

export default MyAppointments;
